module.exports = __webpack_public_path__ + "static/img/bg1.203553e.jpg";